// Go

// Document ready
$(function(){
	// === SVG - Adjust svg according to browser support level

	// Native svg support? Remove some attributes
	// if (Modernizr.svg) {
	  // Scope
	    var states = $('#STATES').find('g'),
	        statelinks = $('#state-links').find('a');
	    states.each(function(){

	      var el = $(this),
	          path = el.find('path'),
	          name = this.id.toLowerCase(),
	          link = statelinks.filter(function(){
	            return ($(this).attr('id').toLowerCase() == 'link-' + name);
	          });
			if (link.length !== 0) {
				// el[0].replaceWith(function() {
			 //    return $('<a/>', { html: this.innerHTML });
				el.click(function() {
			    window.location = link.attr('href');
		        console.log(this);
				});
				// el[0].setAttribute('id', name);
		        // el[0].setAttributeNS('http://www.w3.org/1999/xlink','xlink:href',link.attr('href'));
		        el[0].setAttribute('class','hasLink');
	      }
	    });
	// }// === SVG


});
